import PadraoModel from 'src/core/model/PadraoModel.js'

export default class IcarrosModeloModel extends PadraoModel {
  recurso = 'icarros/modelos';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Modelos Icarros';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor (marca) {
    super()
    this.formLimpo = Object.assign({}, this.form)
    if (marca) this.recurso += `/${marca}`
  }
}
